import { RSFundPageModel } from '../../../../types/server-data/ClientConfig';

export type RstVariableFundingSeries = {
  daily_redemption: number[];
  daily_cost_of_redemption: number[];
  funding_data: {
    dates: string[];
    indicative_info: {
      nav: number;
    };
    fund_redemption: {
      bau: number[];
      stressed: number[];
    };
  };
};

export type RstVariableReport = {
  selected_position_date?: string;
  funding_liquidity_bau: RstVariableFundingSeries;
  funding_liquidity_stressed: RstVariableFundingSeries;
};

export type RstVariablePageModel = RSFundPageModel<RstVariableReport>;

export function extractRstVariableReport(
  page: RstVariablePageModel | null | undefined,
): RstVariableReport | null {
  const inner = page?.data;
  if (!inner || typeof inner !== 'object') return null;
  return inner as RstVariableReport;
}

function isRstVariableReport(value: unknown): value is RstVariableReport {
  if (!value || typeof value !== 'object') return false;
  const v = value as Record<string, unknown>;
  return 'funding_liquidity_bau' in v && 'funding_liquidity_stressed' in v;
}

export function parseRstVariableResponse(
  raw: unknown,
): RstVariablePageModel | null {
  if (raw == null) return null;

  if (Array.isArray(raw)) {
    const first = raw[0];
    if (typeof first === 'string' && first === 'data not available')
      return null;
    if (first && typeof first === 'object' && !Array.isArray(first)) {
      const o = first as Record<string, unknown>;
      if (typeof o.error === 'string' && o.error) throw new Error(o.error);
      if ('no data' in o) return null;
      if (isRstVariableReport(first)) {
        return {
          selected_position_date:
            (first as RstVariableReport).selected_position_date ?? '',
          data: first,
        } as RstVariablePageModel;
      }
    }
    return null;
  }

  if (typeof raw === 'object') {
    const o = raw as Record<string, unknown>;
    if (typeof o.error === 'string' && o.error) throw new Error(o.error);
    if ('no data' in o) return null;

    if (o.data && typeof o.data === 'object' && isRstVariableReport(o.data)) {
      return raw as RstVariablePageModel;
    }

    if (isRstVariableReport(raw)) {
      return {
        selected_position_date:
          (raw as RstVariableReport).selected_position_date ?? '',
        data: raw as RstVariableReport,
      } as RstVariablePageModel;
    }
  }

  return null;
}
